import { create } from "zustand";

import { Scalars, WeeklyEvaluationFragment } from "@/generated/graphql/graphql";

type ID = Scalars["ID"]["input"];

type WeeklySlice = {
  disabledNext: boolean;
  disabledPrev: boolean;
  evaluation: WeeklyEvaluationFragment | null;
  id: ID | null;
  next: () => void;
  prev: () => void;
  setEvaluation: (weeklyEvaluation: WeeklyEvaluationFragment) => void;
};

type EvaluationStore = {
  weekly: WeeklySlice;
};

export const useEvaluationStore = create<EvaluationStore>((set) => {
  return {
    weekly: {
      disabledNext: true,
      disabledPrev: true,
      evaluation: null,
      id: null,
      next: () =>
        set((state) => {
          return {
            ...state,
            weekly: {
              ...state.weekly,
              id: state.weekly.evaluation?.nextId ?? null,
            },
          };
        }),
      prev: () =>
        set((state) => {
          return {
            ...state,
            weekly: {
              ...state.weekly,
              id: state.weekly.evaluation?.prevId ?? null,
            },
          };
        }),
      setEvaluation: (weeklyEvaluation) =>
        set((state) => {
          return {
            ...state,
            weekly: {
              ...state.weekly,
              disabledNext: weeklyEvaluation.nextId === null,
              disabledPrev: weeklyEvaluation.prevId === null,
              evaluation: weeklyEvaluation,
            },
          };
        }),
    },
  };
});
